export default __webpack_public_path__ + "static/media/billy-pointing-to-report.a5a073be.png";